export const darkTheme = {
    background: "#121212",
    color: "#ffffff",
    accent: "#BB86FC",
};